export default {
  notice_create: '新建GCloud业务平台通知',
  notice_title: 'GCloud平台业务通知',
  notice_edit: '修改意见',
  notice_save_draft: '保存草稿',
  notice_send_success: '发送成功',
  notice_send_fail: '发送失败',
  notice_content: '通知正文',
  notice_email_preview: '发送至我的邮箱预览',
  notice_modify: '修改通知',
  notice_new: '新建通知',
  notice_method: '通知方式',
  notice_email: '电子邮件',
  notice_subject: '通知标题',
  notice_scope: '通知范围',
  notice_content_warn: '请添加通知项目',
  notice_content_placeholder: '请输入通知正文',
  notice_insert_field: '插入字段',
  notice_myoa_reminder: 'MyOA提醒',
  notice_myoa_toggle: '开启MyOA提醒',
  notice_myoa_reminder_desc:
    '开启后，通知范围中的项目内部管理员将收到MyOA单据提醒',
  notice_publish_success: '发布成功',
  notice_publish_fail: '发布失败',
  notice_review: '通知审核',
  notice_approve: '审核',
  notice_detail: '通知详情',
  notice_publish: '发布',
  notice_publish_title: '发布内容确认',
  notice_page_publish: '确认发布',
  notice_list_filter_tip:
    '列表中仅展示所选筛选条件，如需查看已选择的通知项目列表，请在通知详情页导出查看。',
  notice_creator: '创建人',
  notice_search: '输入标题搜索',
  notice_status: '通知状态',
  notice_status_off: '未开启',
  notice_status_closed: '已关闭',
  notice_close_doc: '关闭单据',
  notice_last_update: '最近变更时间',
  notice_gcloud_biz: 'GCloud业务',
  notice_gcloud_sdk_ver: 'GCloudSDK版本',
  notice_gcloud_ver: 'GCloud版本',
  notice_component: '组件名',
  notice_component_ver: '组件版本',
  notice_member_count: '项目组成员数',
  notice_kpi_binding: '是否绑定kpi code',
  notice_game_selected: '是否选择通知',
  notice_export: '导出列表',
  notice_selected: '已选择通知',
  notice_selected_summary: '{{gameCount}}个游戏项目，{{memberCount}}位成员',
  notice_selected_summary_table:
    '涵盖 {{gameCount}}个游戏项目，{{memberCount}}位项目成员',
  notice_confirm_reset: '确定要重新添加项目吗？',
  notice_reset_warning: '已经添加的项目会被清空',
  notice_reset: '重新添加',
  notice_add: '添加项目',
  notice_select_all: '全选',
  notice_component_ver_hint: '组件版本（对应上架的GCloud版本）',
  notice_search_btn: '检索',
  notice_download_history: '所选游戏ID的最近一次下载记录将被展示至下方表格中',
  notice_version_filter: '下载过所选版本的游戏项目将会被筛选至下方表格中',

  notice_pending_approval: '待审核',
  notice_pending_update: '待修改',
  notice_draft: '草稿',
  notice_wait_publish: '待发布',
  notice_status_publish: '已发布',

  notice_xlsx_title: '通知范围筛选项​',
  notice_xlsx_no: '序号',
  notice_xlsx_total_info:
    '筛选范围内项目总数 {{total}} 个，选择通知项目 {{selectedCount}} 个',
  notice_xlsx_info:
    '仅展示筛选条件下确定通知的项目，已手动取消通知的范围内项目不展示在列表中。',
  notice_xlsx_member: '项目成员',
  notice_xlsx_admin: '项目管理员',
  notice_xlsx_other: '其他成员',
  notice_xlsx_success: '通知项目列表导出成功',
  notice_xlsx_fail: '通知项目列表导出失败，请重试',
  notice_xlsx_filename_prefix: '项目通知列表',
};
